import localStorageKeys from 'constants/localStorageKeys';
import { isInstallableCMSApp } from 'utils/constants';
import { isExcludedInstallAppModalPath } from 'utils/installAppPrompt';

export const isStandalonePwa = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true ||
        document.referrer.includes('android-app://')
    );
};

export const shouldPersistRoute = (pathname = '') => {
    if (isInstallableCMSApp) {
        return false;
    }

    if (!pathname) {
        return false;
    }

    if (pathname === '/login' || pathname.startsWith('/login/')) {
        return false;
    }

    if (pathname === '/') {
        return true;
    }

    if (isStandalonePwa()) {
        if (
            pathname.includes('moderation-with-magic-link') ||
            pathname.includes('qa-speaker-view')
        ) {
            return true;
        }
    }

    return !isExcludedInstallAppModalPath(pathname);
};

export const buildRoutePath = (pathname = '', search = '', hash = '') =>
    `${pathname || ''}${search || ''}${hash || ''}`;

export const getLastRoute = () =>
    localStorage.getItem(localStorageKeys.LAST_PWA_ROUTE) || '';

export const saveLastRoute = (pathname = '', search = '', hash = '') => {
    if (!shouldPersistRoute(pathname)) {
        return;
    }

    localStorage.setItem(
        localStorageKeys.LAST_PWA_ROUTE,
        buildRoutePath(pathname, search, hash)
    );
};

export const clearLastRoute = () => {
    localStorage.removeItem(localStorageKeys.LAST_PWA_ROUTE);
};

export const restoreLastRouteIfNeeded = () => {
    if (!isStandalonePwa()) {
        return;
    }

    if (
        new URLSearchParams(window.location.search).get('iscleanstorage') ===
        'true'
    ) {
        return;
    }

    const lastRoute = getLastRoute();
    if (!lastRoute) {
        return;
    }

    const currentPath = buildRoutePath(
        window.location.pathname,
        window.location.search,
        window.location.hash
    );

    if (currentPath === lastRoute) {
        return;
    }

    const isLaunchAtRoot =
        window.location.pathname === '/' ||
        window.location.pathname === '/login';

    if (!isLaunchAtRoot) {
        return;
    }

    const restoredPathname = lastRoute.split(/[?#]/)[0];
    if (!shouldPersistRoute(restoredPathname)) {
        return;
    }

    window.history.replaceState(null, '', lastRoute);
};

export const getPostLoginRedirectUrl = () => {
    const redirectUrl = localStorage.getItem(localStorageKeys.REDIRECT_URL);
    if (redirectUrl) {
        return redirectUrl;
    }

    if (!isStandalonePwa()) {
        return '';
    }

    const lastRoute = getLastRoute();
    if (!lastRoute) {
        return '';
    }

    const restoredPathname = lastRoute.split(/[?#]/)[0];
    return shouldPersistRoute(restoredPathname) ? lastRoute : '';
};
